<template>
    <v-form style="height: 100% !important;" :disabled="disabled">
        <v-card
            flat
            elevation="0"
            class="bible-form"
            :loading="loading"
        >
            <v-card-title>
                <span class="header2">{{ $t('data_gatherings.edit_form.title') }}</span>
                <span class="header2">&nbsp;|&nbsp;</span>
                <span class="subtitle" style="font-size: 20px !important">{{ newDataGathering.academic_period.title }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <span class="label">{{ $tc('data_gatherings.title') }}:</span>
                            <v-text-field
                                v-model="newDataGathering.title"
                                outlined
                                class="input-text input-text--textfield body-text"
                                :readonly="readonly"
                                hide-details="auto"
                            />
                        </v-col>
                        <v-col cols="12">
                            <span class="label">{{ $tc('data_gatherings.notes') }}:</span>
                            <v-textarea
                                v-model="newDataGathering.notes"
                                outlined
                                class="input-text body-text"
                                :readonly="readonly"
                                hide-details="auto"
                            />
                        </v-col>
                        <v-col cols="12">
                            <span class="label">{{ $tc('data_gatherings.status') }}:</span>
                            <v-select
                                v-model="newDataGathering.status"
                                :items="currentStatuses"
                                item-value="id"
                                item-text="name"
                                item-disabled="disabled"
                                outlined
                                dense
                                :readonly="readonly"
                                class="input-text input-text--select body-text"
                                hide-details="auto"
                                menu-props="top, overflowY"
                                attach
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    class="v-btn--secondary"
                    @click="cancel"
                >
                    {{ $tc('data_gatherings.cancel') }}
                </v-btn>
                <v-btn
                    class="v-btn--primary"
                    @click="save"
                >
                    {{ $tc('data_gatherings.edit') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>

<script>
import _ from "lodash";
import {mapActions} from "pinia";
import {EventBus} from "@/event-bus";
import DataGatheringRepository from "@/Repositories/DataGathering/DataGatheringRepository";
import {DataGatheringsStore} from "@/Store/DataGatherings/DataGatheringsStore";
import ToastMixin from "@/Shared/toastMixin";
import StrategySelectionMixin from "@/Shared/DathaGatherings/Common/Forms/StrategySelectionMixin";

export default {
    name: "EditForm",

    mixins: [StrategySelectionMixin, ToastMixin],

    props: {
        dataGathering: {
            type: Object,
            require: true,
        },
    },

    data: () => ({
        newDataGathering: DataGatheringRepository.build(),

        currentStatuses: [],

        data_gathering_types: {
            detail_grade_abbr: 'BIBLE_DETAIL_GRADE',
            detail_master_abbr: 'BIBLE_DETAIL_MASTER',
        },

        loading: false,
    }),

    methods: {
        statuses() {
            return DataGatheringRepository
                .getStatuses()
                .map(status => status.setDisabled(this.newDataGathering))
        },

        save() {
            this.loading = true;

            try{
                this.updateDataGathering(this.newDataGathering)
                    .then(data_gathering => {
                        //info the user
                        this.toast().success(this.$t('data_gatherings.edit_form.success', { data_gathering: data_gathering.title }));
                        console.info('data_gathering update successful', data_gathering);
                        //updates the list of select component
                        this.currentStatuses = this.statuses();
                        if (this.isStatusClosed() &&
                            (this.newDataGathering.type.abbr === 'BIBLE_DETAIL_GRADE' ||
                                this.newDataGathering.type.abbr === 'BIBLE_DETAIL_MASTER')) {
                            this.getRecuResume(this.dataGathering).then(data_gathering_resume => {
                                //Add new validation to check if the data gathering is already created
                                if (Object.keys(data_gathering_resume.data).length === 0) {
                                    this.storeResumeFromRecuDetailed();
                                } else {
                                    this.replaceResumeFromRecuDetailed(data_gathering_resume.data);
                                }
                            });
                        }
                        //then emit a local event
                        this.$emit('saved', data_gathering);

                        //close the dialog
                        this.close();
                    })
                    .catch(error => {
                        this.toast().error(this.$t('data_gatherings.edit_form.error', { data_gathering: this.dataGathering.title }));
                        console.error('data_gathering update error', this.dataGathering, error);
                    })
                    .then(() => this.loading = false);
            }
            catch (ex){
                this.toast().error(this.$t('data_gatherings.edit_form.error', { data_gathering: this.dataGathering.title }));
                console.error('data_gathering update exception', ex);
            }
            finally {
                this.loading = false;
            }
        },

        isStatusClosed() {

            return this.newDataGathering.status === 'closed';

        },

        storeResumeFromRecuDetailed() {

            const strategyId = 3;
            const user = _.get(this.$page.props, 'auth');
            const { uuid, title, notes, academic_period, type, status } = this.newDataGathering;
            this.data_gathering.setCreatedBy(user);
            this.data_gathering = {
                ...this.newDataGathering,
                reference_uuid: uuid,
                title: title.replace(/DETALLADO/i, "Resumido"),
                notes,
                academic_period : {
                    ...academic_period,
                    id: academic_period.id,
                },
                type: {
                    ...type,
                    id: this.setDataGatheringType(),
                },
                strategy: { id: strategyId },
                mode: 'manual',
                options: {
                    ...this.data_gathering.options,
                    data_provider: {
                        name: 'recu',
                        uuid: uuid,
                        parent_status: status,
                    }
                }
            };
            this.store(this.data_gathering).then(data_gathering => {
                this.toast().success(
                    this.$t('data_gatherings.generate_form.success_store_title', {data_gathering: data_gathering.title}),
                    this.$t('data_gatherings.generate_form.success_store_message'),
                );
            }).catch(error => {
                this.toast().error(
                    this.$t('data_gatherings.generate_form.error_store_title'),
                    this.$t('data_gatherings.generate_form.error_store_message'),
                );

                console.error('data-gathering.store.error', error, _.cloneDeep(this.data_gathering));
            })
        },

        replaceResumeFromRecuDetailed(data) {

            const user = _.get(this.$page.props, 'auth');
            this.data_gathering.setReplacedBy(user);
            this.data_gathering = {
                ...data,
                options: {
                    ...data.options,
                    data_provider: {...data.options.data_provider, parent_status: this.newDataGathering.status},
                    replaced_by: this.data_gathering.options.replaced_by
                }
            };

            this.replace(this.data_gathering)
                .then(data_gathering => {
                    this.toast().success(
                        this.$t('data_gatherings.replace_form.success_store_title', {data_gathering: data_gathering.title}),
                        this.$t('data_gatherings.replace_form.success_store_message'),
                    );
                })
                .catch(error => {
                    this.toast().error(
                        this.$t('data_gatherings.replace_form.error_store_title'),
                        this.$t('data_gatherings.replace_form.error_store_message'),
                    );

                    console.error('data-gathering.replace.error', error, _.cloneDeep(this.data_gathering));
                })
        },

        setDataGatheringType() {
            if (this.newDataGathering.type.abbr === this.data_gathering_types.detail_grade_abbr)
                return 2;
            if (this.newDataGathering.type.abbr === this.data_gathering_types.detail_master_abbr)
                return 4
        },

        cancel() {
            this.clone();

            this.close();
        },

        close() {
            const data_gathering = _.cloneDeep(this.newDataGathering);

            //emmit a local event
            this.$emit('close', data_gathering);

            //emit a global event
            //EventBus.$emit('data_gatherings.edit-data_gathering.close', data_gathering);
        },

        clone() {
            this.newDataGathering = _.cloneDeep(this.dataGathering);
        },

        ...mapActions(DataGatheringsStore, {
            updateDataGathering: 'update',
            getRecuResume : 'getRecuResume',
            store: 'store',
            replace: 'replace',

        }),
    },

    computed: {
        disabled() {
            return this.isBibleUnderConstruction || this.loading;
        },

        readonly() {
            return false;
        },

        isBibleUnderConstruction() {
            return false;
        },
    },

    watch: {
        dataGathering: {
            handler() {
                this.clone();
            },

            deep: true,
        }
    },

    mounted() {
        this.clone();
        this.currentStatuses = this.statuses();
    },
}
</script>

<style lang="scss" scoped>

::v-deep .v-menu__content {
    max-height: 204px !important;
}
</style>
